import { useContext } from 'react';
import QuestionnaireContext, { QuestionnaireContextType } from './QuestionnaireContext';

const useQuestionnaireContext = (): QuestionnaireContextType => {
  const context = useContext(QuestionnaireContext);
  if (!context) {
    throw new Error('useFormContext must be used within a FormProvider');
  }
  return context;
};

export default useQuestionnaireContext;